/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleLandingPageCommercialContextData } from './GoogleLandingPageCommercialContextData';
import {
    GoogleLandingPageCommercialContextDataFromJSON,
    GoogleLandingPageCommercialContextDataFromJSONTyped,
    GoogleLandingPageCommercialContextDataToJSON,
    GoogleLandingPageCommercialContextDataToJSONTyped,
} from './GoogleLandingPageCommercialContextData';
import type { GoogleLandingPageFunnelRowData } from './GoogleLandingPageFunnelRowData';
import {
    GoogleLandingPageFunnelRowDataFromJSON,
    GoogleLandingPageFunnelRowDataFromJSONTyped,
    GoogleLandingPageFunnelRowDataToJSON,
    GoogleLandingPageFunnelRowDataToJSONTyped,
} from './GoogleLandingPageFunnelRowData';
import type { GoogleLandingPageFunnelSourceData } from './GoogleLandingPageFunnelSourceData';
import {
    GoogleLandingPageFunnelSourceDataFromJSON,
    GoogleLandingPageFunnelSourceDataFromJSONTyped,
    GoogleLandingPageFunnelSourceDataToJSON,
    GoogleLandingPageFunnelSourceDataToJSONTyped,
} from './GoogleLandingPageFunnelSourceData';
import type { GoogleLandingPageFunnelSummaryData } from './GoogleLandingPageFunnelSummaryData';
import {
    GoogleLandingPageFunnelSummaryDataFromJSON,
    GoogleLandingPageFunnelSummaryDataFromJSONTyped,
    GoogleLandingPageFunnelSummaryDataToJSON,
    GoogleLandingPageFunnelSummaryDataToJSONTyped,
} from './GoogleLandingPageFunnelSummaryData';

/**
 * 
 * @export
 * @interface GoogleLandingPageFunnelData
 */
export interface GoogleLandingPageFunnelData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelData
     */
    searchConsoleAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelData
     */
    ga4Available?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleLandingPageFunnelData
     */
    partial?: boolean;
    /**
     * Currency of GA4 measurement revenue for the selected property.
     * @type {string}
     * @memberof GoogleLandingPageFunnelData
     */
    analyticsCurrency?: string;
    /**
     * Currency of ERP accounting turnover.
     * @type {string}
     * @memberof GoogleLandingPageFunnelData
     */
    projectCurrency?: string;
    /**
     * 
     * @type {GoogleLandingPageFunnelSourceData}
     * @memberof GoogleLandingPageFunnelData
     */
    searchConsoleSource?: GoogleLandingPageFunnelSourceData | null;
    /**
     * 
     * @type {GoogleLandingPageFunnelSourceData}
     * @memberof GoogleLandingPageFunnelData
     */
    ga4Source?: GoogleLandingPageFunnelSourceData | null;
    /**
     * 
     * @type {GoogleLandingPageFunnelSummaryData}
     * @memberof GoogleLandingPageFunnelData
     */
    summary?: GoogleLandingPageFunnelSummaryData;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelData
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelData
     */
    totalRows?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelData
     */
    totalPages?: number;
    /**
     * 
     * @type {Array<GoogleLandingPageFunnelRowData>}
     * @memberof GoogleLandingPageFunnelData
     */
    rows?: Array<GoogleLandingPageFunnelRowData>;
    /**
     * 
     * @type {Array<GoogleLandingPageCommercialContextData>}
     * @memberof GoogleLandingPageFunnelData
     */
    commercialContexts?: Array<GoogleLandingPageCommercialContextData>;
}

/**
 * Check if a given object implements the GoogleLandingPageFunnelData interface.
 */
export function instanceOfGoogleLandingPageFunnelData(value: object): value is GoogleLandingPageFunnelData {
    return true;
}

export function GoogleLandingPageFunnelDataFromJSON(json: any): GoogleLandingPageFunnelData {
    return GoogleLandingPageFunnelDataFromJSONTyped(json, false);
}

export function GoogleLandingPageFunnelDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageFunnelData {
    if (json == null) {
        return json;
    }
    return {
        
        'searchConsoleAvailable': json['searchConsoleAvailable'] == null ? undefined : json['searchConsoleAvailable'],
        'ga4Available': json['ga4Available'] == null ? undefined : json['ga4Available'],
        'partial': json['partial'] == null ? undefined : json['partial'],
        'analyticsCurrency': json['analyticsCurrency'] == null ? undefined : json['analyticsCurrency'],
        'projectCurrency': json['projectCurrency'] == null ? undefined : json['projectCurrency'],
        'searchConsoleSource': json['searchConsoleSource'] === undefined ? undefined : json['searchConsoleSource'] === null ? null : GoogleLandingPageFunnelSourceDataFromJSON(json['searchConsoleSource']),
        'ga4Source': json['ga4Source'] === undefined ? undefined : json['ga4Source'] === null ? null : GoogleLandingPageFunnelSourceDataFromJSON(json['ga4Source']),
        'summary': json['summary'] == null ? undefined : GoogleLandingPageFunnelSummaryDataFromJSON(json['summary']),
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'totalRows': json['totalRows'] == null ? undefined : json['totalRows'],
        'totalPages': json['totalPages'] == null ? undefined : json['totalPages'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleLandingPageFunnelRowDataFromJSON)),
        'commercialContexts': json['commercialContexts'] == null ? undefined : ((json['commercialContexts'] as Array<any>).map(GoogleLandingPageCommercialContextDataFromJSON)),
    };
}

export function GoogleLandingPageFunnelDataToJSON(json: any): GoogleLandingPageFunnelData {
    return GoogleLandingPageFunnelDataToJSONTyped(json, false);
}

export function GoogleLandingPageFunnelDataToJSONTyped(value?: GoogleLandingPageFunnelData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchConsoleAvailable': value['searchConsoleAvailable'],
        'ga4Available': value['ga4Available'],
        'partial': value['partial'],
        'analyticsCurrency': value['analyticsCurrency'],
        'projectCurrency': value['projectCurrency'],
        'searchConsoleSource': GoogleLandingPageFunnelSourceDataToJSON(value['searchConsoleSource']),
        'ga4Source': GoogleLandingPageFunnelSourceDataToJSON(value['ga4Source']),
        'summary': GoogleLandingPageFunnelSummaryDataToJSON(value['summary']),
        'page': value['page'],
        'limit': value['limit'],
        'totalRows': value['totalRows'],
        'totalPages': value['totalPages'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleLandingPageFunnelRowDataToJSON)),
        'commercialContexts': value['commercialContexts'] == null ? undefined : ((value['commercialContexts'] as Array<any>).map(GoogleLandingPageCommercialContextDataToJSON)),
    };
}

